/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStatusDaeEnum } from './APIStatusDaeEnum';
import {
    APIStatusDaeEnumFromJSON,
    APIStatusDaeEnumFromJSONTyped,
    APIStatusDaeEnumToJSON,
} from './APIStatusDaeEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APISupplyOrder
 */
export interface APISupplyOrder {
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrder
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrder
     */
    supplier: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrder
     */
    article: string;
    /**
     * 
     * @type {Date}
     * @memberof APISupplyOrder
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APISupplyOrder
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {APIStatusDaeEnum}
     * @memberof APISupplyOrder
     */
    status?: APIStatusDaeEnum;
    /**
     * 
     * @type {Date}
     * @memberof APISupplyOrder
     */
    readonly orderDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof APISupplyOrder
     */
    dueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrder
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrder
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrder
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APISupplyOrder
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APISupplyOrder
     */
    approval?: boolean;
}



/**
 * Check if a given object implements the APISupplyOrder interface.
 */
export function instanceOfAPISupplyOrder(value: object): value is APISupplyOrder {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('supplier' in value) || value['supplier'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APISupplyOrderFromJSON(json: any): APISupplyOrder {
    return APISupplyOrderFromJSONTyped(json, false);
}

export function APISupplyOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): APISupplyOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'supplier': json['supplier'],
        'article': json['article'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'status': json['status'] == null ? undefined : APIStatusDaeEnumFromJSON(json['status']),
        'orderDate': (new Date(json['order_date'])),
        'dueDate': (new Date(json['due_date'])),
        'amount': json['amount'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'description': json['description'] == null ? undefined : json['description'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'approval': json['approval'] == null ? undefined : json['approval'],
    };
}

export function APISupplyOrderToJSON(value?: Omit<APISupplyOrder, 'self'|'created_at'|'last_modified_at'|'order_date'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'supplier': value['supplier'],
        'article': value['article'],
        'status': APIStatusDaeEnumToJSON(value['status']),
        'due_date': ((value['dueDate']).toISOString()),
        'amount': value['amount'],
        'unit': value['unit'],
        'description': value['description'],
        'comment': value['comment'],
        'approval': value['approval'],
    };
}

